export default {
  PROFILE: "Profile",
  PURCHASEDMOCKTESTS: "Purchased Mocktests",
  ATTEMPTS: "Attempts",
  STATS: "Stats",
  COURSES: "Courses",
  COURSE: "Courses",
  LASTLOGGEDIN: "Last Logged in",
};
